var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('img',{staticClass:"dev-logo",attrs:{"src":require("..\\public\\devengers-white.png")}}),_c('div',{staticClass:"devs"},[_c('ul',[_c('li',[_vm._v("Herman Grewal")]),_c('li',[_vm._v("Robin Kim")]),_c('li',[_vm._v("Maxwell MacFarlane")]),_c('li',[_vm._v("David Sensendorf")]),_c('li',[_vm._v("Justin Wagner")])])])])
}]

export { render, staticRenderFns }